/* globals sessionStorage */

import { fetch } from './api'
import { encrypt } from './common'

export function login (username, password, callback) {
  fetch({
    method: 'post',
    url: 'login',
    data: {
      loginPassword: encrypt(password),
      loginName: username,
      url: 'login'
    }
  }).then(function (data) {
    if (data) {
      sessionStorage.token = data.token
      sessionStorage.customerId = data.customerId
      let thisTime = new Date().getTime() + 1000 * 60 * 30
      sessionStorage.expireTime = thisTime
      callback()
    }
  })
}
export function expire () {
  let expireTime = sessionStorage.expireTime
  if (!expireTime) {
    exit()
    logout()
    return false
  }
  let thisTime = new Date().getTime()
  if (thisTime > expireTime) {
    exit()
    logout()
    return false
  } else {
    sessionStorage.expireTime = thisTime + 1000 * 60 * 30
    return true
  }
}
export function setCurrentPage (page) {
  sessionStorage.currentPage = page
  expire()
}
export function getCurrentPage (page) {
  expire()
  return sessionStorage.currentPage
}
export function getToken () {
  expire()
  return sessionStorage.token
}
export function getRealname () {
  expire()
  return sessionStorage.realname
}
export function getCustomerId () {
  expire()
  return sessionStorage.customerId
}
export function logout (callback) {
  delete sessionStorage.token
  delete sessionStorage.realname
  delete sessionStorage.customerId
  delete sessionStorage.paths
  delete sessionStorage.actions
  delete sessionStorage.expireTime
  if (callback) callback()
}
export function exit () {
  delete sessionStorage.token
  delete sessionStorage.realname
  delete sessionStorage.customerId
  delete sessionStorage.paths
  delete sessionStorage.actions
  delete sessionStorage.expireTime
}
export function loggedIn () {
  expire()
  return !!sessionStorage.token
}
export function getActions () {
  expire()
  return sessionStorage.actions ? sessionStorage.actions.split(',') : []
}

export function checkActions (action) {
  expire()
  const actions = getActions()
  return actions.indexOf(action) >= 0
}

export function requireAuth (to, from, next) {
  expire()
  if (!sessionStorage.token) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

export const pathFormat = (menus) => {
  expire()
  let paths = {}
  menus.map(menu => {
    if (menu.parentId) {
      const pMenu = menus.find(pMenu => pMenu.id === menu.parentId)
      if (pMenu) {
        const pMenuPath = pMenu.url
        if (!paths[pMenuPath]) {
          paths[pMenuPath] = []
        }
        paths[pMenuPath].push(menu.url)
      }
    }
  })
  return paths
} // 输入全部有权限的路径，输出全部有权限的路径的父子关系，用于路由跳转

export const pathRedirect = (to) => {
  if (!sessionStorage.token || !sessionStorage.paths) {
    return '/login'
  }
  const paths = JSON.parse(sessionStorage.paths) // 获取路径的父子关系
  const { matched } = to
  const path = matched[matched.length - 1].path // 获取跳转路径
  if (path === '') {
    return Object.keys(paths)[0]
  } // 如果路径为空，跳转到第一条路径
  console.log(paths)
  return paths[path][0]
} // 输入父模块路径，自动计算拥有的权限的子模块路径

export const getAccount = (callback) => {
  expire()
  if (!sessionStorage.realName) {
    fetch({
      method: 'get',
      url: 'rbac/user/get'
    }).then(response => {
      sessionStorage.realname = response.name
      sessionStorage.paths = JSON.stringify(pathFormat(response.menus.filter(item => item.type !== 'BUTTON')))
      sessionStorage.actions = response.menus.filter(item => item.type === 'BUTTON').map(item => {
        return item.url
      })
      callback(response)
    })
  }
} // 输入父模块路径，自动计算拥有的权限的子模块路径




// WEBPACK FOOTER //
// ./src/utils/auth.js